import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/contract.jpg"
import {FiCpu, FiDatabase, FiLock, FiArrowRight} from '../assets/icons/vander'

export default function AboutTwo(){
    return(
        <>
            <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                    <div className="relative order-1 md:order-2">
                        <div className="relative overflow-hidden rounded-lg border border-amber-400/5 bg-gradient-to-tl to-amber-400/30 from-fuchsia-600/30 dark:to-amber-400/50 dark:from-fuchsia-600/50 pe-6 pt-6 lg:ms-8">
                            <img src={aboutImg} className="ltr:rounded-tr-lg rtl:rounded-tl-lg transform hover:scale-105 transition-transform duration-500" alt=""/>
                        </div>
                    </div>

                    <div className="order-2 md:order-1 space-y-6">
                        <div>
                            <h4 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Cutting-Edge Technology, <br/> <span className="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">Local-First Architecture</span></h4>
                            <p className="text-slate-400">Experience enterprise-grade AI without compromising security. Our architecture ensures your data never leaves your premises while delivering powerful AI capabilities.</p>
                        </div>

                        <div className="grid gap-6">
                            <div className="flex items-start gap-4">
                                <div className="min-w-[45px] h-11 w-11 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                    <FiCpu className="h-6 w-6"/>
                                </div>
                                <div>
                                    <h5 className="text-lg font-semibold mb-2">RAG-Powered Intelligence</h5>
                                    <p className="text-slate-400">Our advanced Retrieval-Augmented Generation technology ensures precise, context-aware responses from your documents and data.</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="min-w-[45px] h-11 w-11 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                    <FiDatabase className="h-6 w-6"/>
                                </div>
                                <div>
                                    <h5 className="text-lg font-semibold mb-2">Local Embeddings</h5>
                                    <p className="text-slate-400">All data processing happens on your infrastructure. Your sensitive information never touches external servers or cloud services.</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="min-w-[45px] h-11 w-11 flex items-center justify-center bg-amber-400/5 dark:bg-amber-400/10 text-amber-400 rounded-lg">
                                    <FiLock className="h-6 w-6"/>
                                </div>
                                <div>
                                    <h5 className="text-lg font-semibold mb-2">Open-Source Foundation</h5>
                                    <p className="text-slate-400">Built on trusted open-source LLMs, our solution offers transparency and eliminates black-box AI concerns.</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6">
                            <Link to="/contact" className="inline-flex items-center gap-2 font-semibold text-amber-400 hover:text-amber-500 transition-colors duration-300">
                                Explore Our Architecture <FiArrowRight className="h-5 w-5"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}